import type { ContenidoAyuda } from "@/ui/AyudaVista";
import { FICHA_ACTIVIDAD, FICHA_IMEIS } from "./fichasCaso";

/**
 * Ayuda del Panel principal (Dashboard). Antes, el «?» con globito, los
 * tooltips de las cuatro tarjetas y los `title` de los switches y del «+N».
 */
export function ayudaPanel(): ContenidoAyuda {
  return {
    manual: "panel",
    intro: (
      <p>
        El vistazo de la mañana: cuántos casos hay, tus alertas sin leer, los tickets donde el
        proveedor ya contestó y la lista de casos activos para buscar rápido.
      </p>
    ),
    secciones: [
      {
        titulo: "Qué significa cada tarjeta",
        items: [
          { label: "Abiertos", text: "Casos en cualquier estado menos Cerrado: la pila de trabajo de todo el equipo." },
          {
            label: "Alertas",
            text: "Tus alertas sin leer: casos por quemarse o quemados, escalaciones, correos nuevos, asignaciones, menciones, recordatorios y avisos del sistema. Se leen en Alertas.",
          },
          { label: "Cerrados", text: "Casos en estado Cerrado, de siempre." },
          { label: "Total", text: "Abiertos más cerrados." },
          {
            label: "N tickets donde el proveedor ya contestó",
            text: "Sale solo si hay alguno: casos donde Jimi o Queclink respondieron en su ticket y nosotros todavía no. El borde se pone rojo cuando el más viejo lleva 5 días o más. Tócala para ver la lista.",
          },
        ],
      },
      {
        titulo: "Qué hace cada botón",
        items: [
          { label: "Ver estadísticas de soporte →", text: "Abre Estadísticas." },
          {
            label: "Un caso de la lista",
            text: "Tócalo para abrir el caso.",
          },
          {
            label: "+N más",
            text: "El caso trae más equipos de los que caben: tócalo para ver todos sus IMEIs ahí mismo, y «ver menos» para plegarlos.",
          },
          {
            label: "▸ Nombre del cliente",
            text: "Con «Agrupar por cliente» prendido, abre o cierra los casos de esa empresa. Empiezan cerrados.",
          },
          { label: "Expandir todo / Colapsar todo", text: "Abre o cierra todos los grupos de un jalón." },
          {
            label: "Filtros (celular)",
            text: "En el celular el cliente, el asignado, el modelo e «Incluir cerrados» viven en este botón; el número es cuántos tienes puestos.",
          },
          { label: "Limpiar", text: "Quita la búsqueda y todos los filtros." },
        ],
      },
      {
        titulo: "Filtros y búsqueda",
        items: [
          {
            label: "Buscador",
            text: "Filtra al instante los casos activos por IMEI (completo o un pedazo), folio, cliente, TE, marca, modelo, ticket de Jimi o asignado. No distingue mayúsculas ni acentos.",
          },
          {
            label: "Incluir cerrados",
            text: "Con texto en el buscador, busca además en los casos cerrados de toda la base (con la misma búsqueda de la vista Casos) y los enseña aparte, abajo, hasta 50.",
          },
          { label: "Agrupar por cliente", text: "Junta los casos activos en secciones plegables, una por empresa, de la que más casos tiene a la que menos." },
          { label: "Clientes / asignados / modelos", text: "Solo los casos activos de ese cliente, de esa persona (o sin asignar) o de ese modelo." },
        ],
      },
      {
        titulo: "Qué significa cada ficha",
        items: [
          {
            label: "Ficha de estado",
            text: "El estado del caso (Abierto, En revisión, Listo para enviar, Enviado al proveedor, Esperando proveedor, Pendiente cliente).",
          },
          FICHA_ACTIVIDAD,
          FICHA_IMEIS,
        ],
      },
    ],
  };
}
